 
export const HTTP_STATUS_OK = 200;
export const HTTP_STATUS_CREATED = 201;
export const HTTP_STATUS_NOCONTENT = 204;
export const HTTP_STATUS_BADREQUEST = 400;
export const HTTP_STATUS_UNAUTHORIZED = 401;
export const HTTP_STATUS_NOTFOUND = 404;
export const HTTP_STATUS_INTERNALSERVERERROR = 500;
export const HTTP_STATUS_SERVICEUNAVAILABLE = 503;
